import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

import { Alert, palette, SecondaryButton, TertiaryButton, TextArea, Typography } from '@dev/ee-components';
import { getCheckoutsTermsStore, CheckoutsTermsUpdate } from "@/store/checkoutTerms/actions";

import { AlertWrapper, ButtonsWrapper, CancelButtonWrapper } from '../styles';

export const TermsAndConditionsBody = (): JSX.Element => {
    const { t } = useTranslation();
    const { terms } = useSelector(getCheckoutsTermsStore);
    const [isTextAreaReadOnly, setTextAreaReadOnly] = useState(true);
    const [ termsText, setTermsText ] = useState(terms);
    const currentTermsText = terms;
    const dispatch = useDispatch();

    const handleChangeTextArea = (content): void => {
        const value = content?.target?.value;
        setTermsText(value);
    };

    const handleEditButtonClick = (): void => {
        setTextAreaReadOnly(!isTextAreaReadOnly);
    };

    const handleCancelButtonClick = (): void => {
        setTermsText(currentTermsText);
        setTextAreaReadOnly(!isTextAreaReadOnly);
    };

    const handleSaveButtonClick = (): void => {
        dispatch(CheckoutsTermsUpdate({ terms: termsText, isDefault: false }));
        setTextAreaReadOnly(!isTextAreaReadOnly);
    };

    return (
        <>
            {isTextAreaReadOnly ?
                <Typography variant='body1'>{t('termsandconditions_templatedesc')}</Typography> :
                <AlertWrapper>
                    <Alert severity='info' body={t('termsandconditions_info')} />
                </AlertWrapper>
            }
            <Box mt="24px" mb="24px">
                <TextArea
                    name={'terms-and-conditions-input'}
                    id={'terms-and-conditions-input'}
                    value={termsText}
                    onChange={handleChangeTextArea}
                    height={320}
                    readOnly={isTextAreaReadOnly}
                    style={{ backgroundColor: `${palette.snow[2]}`, marginBottom: 0, overflow: 'overlay' }}
                />
            </Box>
            <ButtonsWrapper>
                {isTextAreaReadOnly ?
                    <TertiaryButton
                        text={t('edittermsandconditions')}
                        onClick={handleEditButtonClick}
                    /> :
                    <>
                        <CancelButtonWrapper>
                            <TertiaryButton
                                text={t('cancel')}
                                onClick={handleCancelButtonClick}
                            />
                        </CancelButtonWrapper>
                        <SecondaryButton 
                            text={t('save')}
                            onClick={handleSaveButtonClick}
                        />
                    </>
                }
            </ButtonsWrapper> 
        </>
    );
};
